
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, Star, TrendingUp, ThumbsUp } from 'lucide-react';
import { usePhemexLang } from '@/contexts/PhemexLangContext';

const FeaturesSection = () => {
  const { t } = usePhemexLang();
  
  return (
    <div className="py-16 px-4 bg-black">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-2" style={{ color: '#38d102' }}>
          {t.features.title}
        </h2>
        <p className="text-center text-gray-300 mb-12">
          {t.features.subtitle}
        </p>
        
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {/* Feature 1 */}
          <div className="bg-black border border-gray-800 rounded-lg p-6">
            <div className="bg-gray-800 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
              <Star size={24} style={{ color: '#38d102' }} />
            </div>
            <h3 className="text-xl font-bold mb-2 text-white">{t.features.feature1.title}</h3>
            <p className="text-gray-400">
              {t.features.feature1.description}
            </p>
          </div>
          
          {/* Feature 2 */}
          <div className="bg-black border border-gray-800 rounded-lg p-6">
            <div className="bg-gray-800 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
              <TrendingUp size={24} style={{ color: '#38d102' }} />
            </div>
            <h3 className="text-xl font-bold mb-2 text-white">{t.features.feature2.title}</h3>
            <p className="text-gray-400">
              {t.features.feature2.description}
            </p>
          </div>
          
          {/* Feature 3 */}
          <div className="bg-black border border-gray-800 rounded-lg p-6">
            <div className="bg-gray-800 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
              <ThumbsUp size={24} style={{ color: '#38d102' }} />
            </div>
            <h3 className="text-xl font-bold mb-2 text-white">{t.features.feature3.title}</h3>
            <p className="text-gray-400">
              {t.features.feature3.description}
            </p>
          </div>
        </div>
        
        <div className="flex justify-center">
          <Link to="/signup?campaign=phemex">
            <Button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-6 text-lg rounded-full flex items-center gap-2">
              {t.hero.startTrading} <ArrowRight className="ml-1" size={20} />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FeaturesSection;
